export const getProductionWorkOrderAutocompleteList = state => {
    return state.autocomplete_list
}

export const getProductionWorkerWorkStatusList = state => {
    return state.worker_work_status_list
}

export const getProductionWorkOrderList = state => {
    return state.list
}

export const getReadyOrderList = state => {
    return state.ready_orders
}

export const getPlannerList = state => {
    return state.planner.list
}


// WEBPACK FOOTER //
// ./src/store/modules/production/getters.js